import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyTotalenergiesMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  const bgGradient = (
    <defs>
      <linearGradient id="totalGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: "#00205B", stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: "#009DF5", stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#FFB612", stopOpacity: 0.3 }} />
      </linearGradient>
    </defs>
  );

  const waveFields: JSX.Element[] = [];
  for (let wave = 0; wave < 14; wave++) {
    const points: string[] = [];
    const y = -480 + wave * 70;
    for (let p = 0; p <= 40; p++) {
      const t = p / 40;
      const x = -360 + t * 720;
      const yOffset = Math.sin(t * Math.PI * 3 + wave * 0.5) * 35;
      points.push(`${x},${y + yOffset}`);
    }
    waveFields.push(
      <polyline
        key={`wave-${wave}`}
        points={points.join(" ")}
        fill="none"
        stroke="#009DF5"
        strokeWidth={2}
        opacity={0.25}
      />
    );
  }

  const solarCircles: JSX.Element[] = [];
  for (let c = 1; c <= 16; c++) {
    const radius = c * 25;
    solarCircles.push(
      <circle
        key={`solar-${c}`}
        cx={0}
        cy={0}
        r={radius}
        fill="none"
        stroke="#FFB612"
        strokeWidth={c % 3 === 0 ? 2.5 : 1.5}
        opacity={0.3 - c * 0.014}
      />
    );
  }

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      {bgGradient}
      <rect width={width} height={height} fill="url(#totalGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {waveFields}
        {solarCircles}
        <circle cx={0} cy={0} r={60} fill="none" stroke="#FFB612" strokeWidth={4} opacity={0.6} />
        <circle cx={0} cy={0} r={40} fill="#009DF5" opacity={0.3} />
      </g>
    </svg>
  );
}
